import React from "react";
import { mergeStyles } from "@fluentui/react/";

import { Text, ITextStyles } from "@fluentui/react/";
import { FontSizes } from "@fluentui/react/";
import { FontWeights } from "@fluentui/react/";

import {
  titleS,
  subTitleS,
  textContainerS,
} from "../../styles/detailTxt.style";


const wrapper = mergeStyles({
  display: "flex",
  justifyContent: "space-between",
});

const mainWrapper = mergeStyles({
  paddingTop: 20,
  paddingBottom: 15
})
const divider = mergeStyles({
  width: 250,
});

export interface PricesProps {
  value: number;
  quantity: number
}
const headerS: ITextStyles = {
  root: {
    display: "block",
    marginBottom: 15,
    fontSize: FontSizes.size16,
    fontWeight: FontWeights.semibold,
  },
};

const PricesShow: React.FC<PricesProps> = ({ value, quantity }) => {
  return (
    <div className={mainWrapper} >
      <Text styles={headerS}>Szacowany koszt zamówienia</Text>
      <div className={wrapper}>
        <div className={divider}>
          <div className={textContainerS}>
            <Text styles={titleS}>Wartość netto</Text>
            <Text styles={subTitleS}>
                {(value * quantity).toFixed(2).toString()} 
            </Text>
          </div>
        </div>
        <div className={divider}>
          <div className={textContainerS}>
            <Text styles={titleS}>Wartość brutto</Text>
            <Text styles={subTitleS}>
                {(value * quantity * 1.08).toFixed(2).toString()} 
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricesShow;
